import React from 'react';
import { formatSeconds, Images, goalDataTypeEnums } from 'utils';
import { latencyEnumBtn, latencyEnums } from '../../../../../clinicalFragments/session/core/sessionCards/constants';
import moment from 'moment/moment';

export const trialDataHead = (type) => {
    switch (type) {
        case goalDataTypeEnums.RATE:
            return [
                { name: 'trial', title: 'Trial', custom: false, noSearch: true },
                { name: 'startTime', title: 'Start Time', custom: false, noSearch: true },
                { name: 'endTime', title: 'End Time', custom: false, noSearch: true },
                { name: 'duration', title: 'Duration', custom: false, noSearch: true },
                { name: 'frequency', title: 'Frequency', custom: false, noSearch: true },
                { name: 'rate', title: 'Rate', custom: false, noSearch: true },
                { name: 'time', title: 'Time Collected', custom: false, noSearch: true },
            ];

        case goalDataTypeEnums.DURATION:
        case goalDataTypeEnums.IRT:
            return [
                { name: 'trial', title: 'Trial', custom: false, noSearch: true },
                { name: 'startTime', title: 'Start Time', custom: false, noSearch: true },
                { name: 'endTime', title: 'End Time', custom: false, noSearch: true },
                { name: 'duration', title: 'Duration', custom: false, noSearch: true },
                { name: 'time', title: 'Time Collected', custom: false, noSearch: true },
            ];

        case goalDataTypeEnums.WHOLE_INTERVAL:
        case goalDataTypeEnums.PARTIAL_INTERVAL:
        case goalDataTypeEnums.MOMENTARY_TIME_SAMPLING:
            return [
                { name: 'trial', title: 'Trial', custom: false, noSearch: true },
                { name: 'startTime', title: 'Start Time', custom: false, noSearch: true },
                { name: 'endTime', title: 'End Time', custom: false, noSearch: true },
                { name: 'prompt', title: 'Prompt', custom: false, noSearch: true },
                { name: 'time', title: 'Time Collected', custom: false, noSearch: true },
            ];

        case goalDataTypeEnums.LATENCY:
            return [
                { name: 'trial', title: 'Trial', custom: false, noSearch: true },
                { name: 'latency', title: 'Latency', custom: false, noSearch: true },
                { name: 'prompt', title: 'Prompt', custom: false, noSearch: true },
                { name: 'time', title: 'Time Collected', custom: false, noSearch: true },
            ];

        case goalDataTypeEnums.FREQUENCY:
            return [
                { name: 'trial', title: 'Trial', custom: false, noSearch: true, width: '45%' },
                { name: 'frequency', title: 'Frequency', custom: false, noSearch: true, width: '40%' },
                { name: 'time', title: 'Time Collected', custom: false, noSearch: true, width: '15%' },
            ];

        case goalDataTypeEnums.RATING:
            return [
                { name: 'trial', title: 'Trial', custom: false, noSearch: true, width: '45%' },
                { name: 'rate', title: 'Rate', custom: false, noSearch: true, width: '40%' },
                { name: 'time', title: 'Time Collected', custom: false, noSearch: true, width: '15%' },
            ];

        default:
            return [
                { name: 'trial', title: 'Trial', custom: false, noSearch: true, width: '45%' },
                { name: 'prompt', title: 'Prompt', custom: false, noSearch: true, width: '40%' },
                { name: 'time', title: 'Time Collected', custom: false, noSearch: true, width: '15%' },
            ];
    }
};

export const trialDataBodyBody = (type) => {
    switch (type) {
        case goalDataTypeEnums.RATE:
            return [
                { rowText: (item, index) => <p>{index + 1}</p> },
                { rowText: (item) => <div>{item?.startTime ? moment(item?.startTime).local().format('h:mm A') : '--'}</div> },
                { rowText: (item) => <div>{item?.endTime ? moment(item?.endTime).local().format('h:mm A') : '--'}</div> },
                { rowText: (item) => <div>{renderAverageRow({ ...item, dataType: type })}</div> },
                { rowText: (item) => <div className="goal-progress-box">{item?.value || 0}</div> },
                { rowText: (item) => <div className="percent-row-box">{`${item?.trialInfo?.value}${item?.trialInfo?.info}`}</div> },
                { rowText: (item) => <div>{item?.timeCollected ? `${moment(item?.timeCollected).local().format('h:mm A')}` : '--'}</div> },
            ];

        case goalDataTypeEnums.DURATION:
        case goalDataTypeEnums.IRT:
            return [
                { rowText: (item, index) => <p>{index + 1}</p> },
                { rowText: (item) => <div>{item?.startTime ? moment(item?.startTime).local().format('h:mm A') : '--'}</div> },
                { rowText: (item) => <div>{item?.endTime ? moment(item?.endTime).local().format('h:mm A') : '--'}</div> },
                { rowText: (item) => <div>{renderAverageRow({ ...item, dataType: type })}</div> },
                { rowText: (item) => <div>{item?.timeCollected ? `${moment(item?.timeCollected).local().format('h:mm A')}` : '--'}</div> },
            ];

        case goalDataTypeEnums.LATENCY:
            return [
                { rowText: (item, index) => <p>{index + 1}</p> },
                { rowText: (item) => formatSeconds(item?.value) },
                { rowText: (item) => <div>{renderAverageRow({ ...item, dataType: type })}</div> },
                { rowText: (item) => <div>{item?.timeCollected ? `${moment(item?.timeCollected).local().format('h:mm A')}` : '--'}</div> },
            ];

        case goalDataTypeEnums.WHOLE_INTERVAL:
        case goalDataTypeEnums.PARTIAL_INTERVAL:
        case goalDataTypeEnums.MOMENTARY_TIME_SAMPLING:
            return [
                { rowText: (item, index) => <p>{index + 1}</p> },
                { rowText: (item) => <div>{item?.startTime ? moment(item?.startTime).local().format('h:mm A') : '--'}</div> },
                { rowText: (item) => <div>{item?.endTime ? moment(item?.endTime).local().format('h:mm A') : '--'}</div> },
                // { rowText: (item) => <div>{formatSeconds(item?.interval)}</div> },
                { rowText: (item) => <div>{renderAverageRow({ ...item, dataType: type })}</div> },
                { rowText: (item) => <div>{item?.timeCollected ? `${moment(item?.timeCollected).local().format('h:mm A')}` : '--'}</div> },
            ];

        default:
            return [
                { rowText: (item, index) => <p>{index + 1}</p> },
                { rowText: (item) => <div>{renderAverageRow({ ...item, dataType: type })}</div> },
                { rowText: (item) => <div>{item?.timeCollected ? `${moment(item?.timeCollected).local().format('h:mm A')}` : '--'}</div> },
            ];
    }
};

export const dataCollectionSessionNotYet = {
    height: '250px',
    title: 'You don’t have Targets yet',
    subTitle: 'Nothing new for now. Enjoy the silence while it lasts',
    image: Images.emptyFolder,
};

export const renderAverageRow = (item) => {
    const startMoment = moment(item?.startTime);
    const endMoment = moment(item?.endTime);
    const differenceInSeconds = endMoment.diff(startMoment, 'seconds');

    switch (item?.dataType) {
        case goalDataTypeEnums.PERCENT:
            return <div className={item?.value ? 'percent-row-box' : 'percent-incorrect-row-box'}>{item?.label}</div>;

        case goalDataTypeEnums.FREQUENCY:
            return <div className="rating-row-box">{`${item?.value}`}</div>;

        case goalDataTypeEnums.RATING:
            return <div className="rating-row-box">{`${item?.value?.toFixed(0)} (${item?.label})`}</div>;

        case goalDataTypeEnums.DURATION:
        case goalDataTypeEnums.IRT:
            return formatSeconds(item?.value);

        case goalDataTypeEnums.RATE:
            return formatSeconds(differenceInSeconds);

        case goalDataTypeEnums.LATENCY:
            return (
                <div
                    className={
                        item?.label === latencyEnums.INCORRECT
                            ? 'percent-incorrect-row-box'
                            : item?.label === latencyEnums.NO_RESPONSE
                              ? 'percent-no-response-row-box'
                              : 'percent-row-box'
                    }
                >
                    {latencyEnumBtn?.find((i) => i?.value === item?.label)?.title}
                </div>
            );

        // <div className={item?.value ? 'percent-row-box' : 'percent-incorrect-row-box'}>{item?.label}</div>;

        case goalDataTypeEnums.WHOLE_INTERVAL:
        case goalDataTypeEnums.PARTIAL_INTERVAL:
        case goalDataTypeEnums.MOMENTARY_TIME_SAMPLING:
            return <div className={item?.value ? 'percent-row-box' : 'percent-incorrect-row-box'}>{item?.value ? 'Yes' : 'No'}</div>;

        case goalDataTypeEnums.SCORE:
            return <div className="rating-row-box">{item?.value}</div>;

        default:
            return item?.value;
    }
};

export const renderTrialAverageRow = (item, resetStyle) => {
    switch (item?.dataType) {
        case goalDataTypeEnums.PERCENT:
        case goalDataTypeEnums.WHOLE_INTERVAL:
        case goalDataTypeEnums.PARTIAL_INTERVAL:
        case goalDataTypeEnums.MOMENTARY_TIME_SAMPLING:
            return <div className={resetStyle ? '' : 'percent-row-box'}>{item?.value}%</div>;

        case goalDataTypeEnums.RATE:
            return (
                <div
                    className={resetStyle ? '' : 'percent-row-box'}
                >{`${item?.tSummary?.trialData?.value} (${item?.tSummary?.trialData?.info})`}</div>
            );

        case goalDataTypeEnums.FREQUENCY:
            return <div className={resetStyle ? '' : 'rating-row-box'}>{`${item?.value}`}</div>;

        case goalDataTypeEnums.RATING:
            return <div className={resetStyle ? '' : 'rating-row-box'}>{`${item?.value?.toFixed(1)}`}</div>;

        case goalDataTypeEnums.DURATION:
        case goalDataTypeEnums.IRT:
            return <div className={resetStyle ? '' : 'percent-row-box'}>{formatSeconds(item?.value)}</div>;

        case goalDataTypeEnums.LATENCY:
            return <div className={resetStyle ? '' : 'percent-row-box'}>{formatSeconds(item?.value)}</div>;
        // return (
        //     <div className={item?.label === latencyEnums.INCORRECT ? "percent-incorrect-row-box" :  "percent-row-box"}>
        //         {latencyEnumBtn?.find((i) => i?.value === item?.label)?.title}
        //     </div>
        // );

        case goalDataTypeEnums.SCORE:
            return <div className={resetStyle ? '' : 'rating-row-box'}>{item?.value}</div>;

        default:
            return item?.value;
    }
};
